import { useCallback } from 'react'
import { useCookies } from 'react-cookie'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { withStyles } from '@aura/components/styles'
import Grid from '@aura/components/grid'
import { useTranslation } from 'react-i18next'
import Box from '@aura/components/box'
import { Button } from '@aura/components'
import Typography from '@aura/components/typography'
import { useAuraThemeSwitcher } from '@aura/components/themes'  
import { useConfig } from '../../utils/config'
import { cookieNameLoginAppCookie } from '../../constants/app'
import { LOGIN_ROUTE } from '../../constants/routes'
import AppBar from '../app-bar-new'
import Footer from '../footer-new'
import SUPPORTED_THEMES from '../../constants/theme'
import styles from './styles'


const TIMEOUT_ILLUSTRATIONS = {
    [SUPPORTED_THEMES.DARK]: '/img/logos/time-out-dark.png',
    [SUPPORTED_THEMES.LIGHT]: '/img/logos/time-out-light.svg'
}

const Component = ({
    classes,
    customVerbiage,
    needToShowHelpText = true
}) => {
    const config = useConfig()
    const { t: translate } = useTranslation()
    const { theme } = useAuraThemeSwitcher()
    const history = useHistory()
    const [ cookies, , removeCookie ] = useCookies([ cookieNameLoginAppCookie ])
    const redirectTo = cookies[cookieNameLoginAppCookie]
    const mainDomain = window.location.hostname.substring(window.location.hostname.indexOf('.'))
    const paletteMode = theme?.palette?.mode
    const title = translate('sessionTimeout')
    const verbiage = translate(`${customVerbiage || 'sessionTimeoutWithTime'}`, { time: config.sessionTimeout })
    const timeoutIllustration = TIMEOUT_ILLUSTRATIONS[paletteMode] || TIMEOUT_ILLUSTRATIONS[SUPPORTED_THEMES.LIGHT]


    const handleOnclick = useCallback(() => {
        removeCookie(cookieNameLoginAppCookie, {
            domain: mainDomain,
            path: '/',
            sameSite: 'strict',
            secure: true
        })

        if (redirectTo) {
            window.location.pathname = `/${redirectTo}/login`
        } else {
            window.location.pathname = LOGIN_ROUTE
        }
    }, [ redirectTo, removeCookie, mainDomain ])


    return (
        <>
            <AppBar />
            <Grid container className={classes.gridContainerCenter}>
                <Grid className={classes.registrationRoot} md={5} sm={8} xs={12}>
                    <Box className={classes.header}>
                        <Box className={classes.illustrationWrapper}>
                            <Box className={classes.illustrationBackground}>
                                <Box className={classes.illustrationIcon}>
                                    <img className={classes.illustrationImage} src={timeoutIllustration} alt={translate('sessionTimeout')} />
                                </Box>
                            </Box>
                        </Box>
                        <Box className={classes.copyWrapper}>
                            <Typography className={classes.title}>{title}</Typography>
                            <Typography className={classes.verbiage}>{verbiage}</Typography>
                            { needToShowHelpText && <Typography className={classes.verbiageHelpText}>{translate('errorPage.helpText')}</Typography>}
                            <Button
                                className={`${classes.returnButton} ${customVerbiage && classes.returnButtonForMagic }`}
                                onClick={handleOnclick}
                                variant='contained'
                            >
                                {translate('errorPage.returnToLogin')}
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Grid container className={classes.gridContainerFooter}>
                <Footer />
            </Grid>
        </>)
}

Component.displayName = 'OktaRegistrationWizard.ErrorPage'

Component.propTypes = {
    classes: PropTypes.shape({
        heading: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        registrationRoot: PropTypes.string.isRequired,
        root: PropTypes.string.isRequired,
        verbiage: PropTypes.string.isRequired
    })
}
export default withStyles(Component, styles)
